<template>
    <v-footer
        absolute
        class='px-0 pb-0'
    >
        <v-card
            tile
            width="100%"
            class="pa-2"
        >
            <v-container fluid>
                <v-row justify="end">
                    <v-btn
                        outlined
                        depressed
                        class="text-none mr-8"
                        @click.prevent="openFunnel"
                    >
                        {{ funnel.text }}
                        <v-icon right>
                            icon-arrow-right
                        </v-icon>
                    </v-btn>
                </v-row>
            </v-container>
        </v-card>
    </v-footer>
</template>

<script>
import { mapGetters } from 'vuex';

    export default {
        name: 'FunnelFooter',
        computed: {
            ...mapGetters('widget', [
                'funnel'
            ])
        },
        methods: {
            openFunnel() {
                window.open(this.funnel.link, '_funnel').focus();
            }
        }
    };
</script>

<style lang="scss" scoped>
    $default-background: #4CAF50;
    $default-text: #FFFFFF;

    $text-button: var(--header-color, $default-text);
    $background-button: var(--header-background-color, $default-background);

    footer.v-footer {
        div.v-card {
            button.v-btn {
                background-color: $background-button;
                color: $text-button;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/funnel/FunnelFooter.vue